import React from 'react';

// Abstract/Creative Logo with Overlapping Shapes
const LogoOption3 = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logo3Gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 0.9 }} />
          <stop offset="100%" style={{ stopColor: '#059669', stopOpacity: 0.9 }} />
        </linearGradient>
        <linearGradient id="logo3Gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#059669', stopOpacity: 0.8 }} />
          <stop offset="100%" style={{ stopColor: '#047857', stopOpacity: 0.8 }} />
        </linearGradient>
      </defs>
      
      {/* Background circle */}
      <circle cx="100" cy="100" r="90" fill="#f0fdf4" />
      
      {/* Overlapping shapes representing connection/network */}
      <circle cx="70" cy="100" r="45" fill="url(#logo3Gradient1)" />
      <circle cx="130" cy="100" r="45" fill="url(#logo3Gradient2)" />
      
      {/* Center highlight */}
      <circle cx="100" cy="100" r="35" fill="#047857" />
      
      {/* TYJ text */}
      <text
        x="100"
        y="110"
        fontFamily="Arial, sans-serif"
        fontSize="45"
        fontWeight="bold"
        fill="white"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        TYJ
      </text>
    </svg>
  );
};

export default LogoOption3;